import { Component } from '@angular/core';
import { FormFieldComponent } from './form-field.component';

@Component({
    selector: 'form-search-field',
    template: `
        <div class="form-group" [formGroup]="form" [hidden]="isHidden" [ngClass]="{'has-error': hasError()}">
            <div class="input-group">
                <input  formControlName="{{name}}" type="text" class="form-control" id ="{{name}}" [ngClass]="{'opaque': isInherited()}" [placeholder]="'Filter by keyword' | localize" style="border-right: transparent">
                <div class="input-group-append">
                    <button class="btn btn-default search-button" style="border-left: transparent">
                        <span class="material-icons-outlined">keyboard_return</span>
                    </button>
                </div>
            </div>
        </div>
    `,
    styles: [`
        button {
            pointer-events: none;
        }
    `]
})
export class FormSearchFieldComponent extends FormFieldComponent {
}